import { useEffect, useState } from "react";
import { columnsheadId } from "../../universal/columnshead";
import AdUploadFileEdit from "./AdUploadFileEdit";
import systemExpand from "../../../config/systemExpand";
import UploadFileListUniversal, { UFLUExtendPropsType } from "../../system/UploadFileListUniversalNewEx";
import { Tooltip } from "antd";

//组件 AdUploadFile
export default function AdUploadFile(props: any) {

    //extendProps
    const [extendProps, setExtendProps] = useState<UFLUExtendPropsType>();

    //表头
    const columnsHead = [
        {
            title: '所属广告',
            dataIndex: 'adName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.ad.adName}</div>
                )
            }
        },
        {
            title: '腾讯视频ID',
            dataIndex: 'movieId',
            render: (text: any, record: any) => {
                return (
                    <Tooltip placement="right" styles={{ root: { maxWidth: 'none' } }} title={showMovie(record.movieId)}>
                        <div>{text}</div>
                    </Tooltip>
                )
            }
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];

    const showMovie = (movieId: any) => {
        const tencentEmbedUrl = 'https://v.qq.com/txp/iframe/player.html?vid=' + movieId;
        return (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe
                width="640"
                height="360"
                src={tencentEmbedUrl}
            // allowFullScreen
            />
        );
    }

    const filesColumns = columnsheadId
        .concat(columnsHead as []);

    useEffect(() => {
        systemExpand.getConfig({
            id: 'config',
            nodeId: 'files'
        }).then(res => {
            const { files } = res as any;
            const { adFilesGroupId } = files;
            setExtendProps({
                ...props,
                titleName: '广告图片',
                apiId: 'ad',
                filesGroupId: adFilesGroupId,
                fileType: "files",
                //+ File
                //上传 + UploadFile
                //删除 + DeleteFile
                filesColumns,
                showImage: true,
                showDownload: true,
                showStates: true,
                showDefault: true,
                extendIdName: "adId",
                EditComponent: AdUploadFileEdit,
                disableCheckBox: sessionStorage.getItem('isAdmin') === 'true' ? false : true
            })
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (extendProps) {
        return (
            <UploadFileListUniversal props={extendProps} />
        )
    }
}